export enum EnCustomerAction {
    FirstAccess,
    CustomerRegistration,
    CustomerAction
}
